import './style/index.less';
import CorpName from './CorpName';

export default CorpName;
